// extracted by mini-css-extract-plugin
export var dataCell = "_j8-2";
export var dataRow = "_j8-0";
export var headerRow = "_j8-1";